import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp, ChevronsUp, Plus } from "lucide-react";
import { api } from "../../lib/api";
import { imgSrc, priceLabel } from "../../data/artworks";
import { useCats } from "../../lib/settings";
import { ArtworkEditor } from "./ArtworkEditor";

export const ArtworksAdmin = () => {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const CATS = useCats();
  useEffect(() => { api.get("/artworks").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => {}); }, []);

  const saved = (a, isNew) => { setItems((p) => (isNew ? [a, ...p] : p.map((x) => (x.id === a.id ? a : x)))); setEdit(null); };
  const toggleSold = async (a) => {
    const { id, order, created_at, ...body } = a;
    const { data } = await api.put(`/admin/artworks/${id}`, { ...body, vendu: !a.vendu });
    setItems((p) => p.map((x) => (x.id === id ? data : x)));
  };
  const remove = async (id) => { await api.delete(`/admin/artworks/${id}`); setItems((p) => p.filter((x) => x.id !== id)); setConfirm(null); };
  const move = async (from, to) => {
    if (to < 0 || to >= items.length) return;
    const next = [...items]; const [a] = next.splice(from, 1); next.splice(to, 0, a);
    setItems(next);
    await api.put("/admin/artworks-order", { ids: next.map((x) => x.id) });
  };
  const arrow = "w-9 h-9 grid place-items-center rounded-full border border-[#15202B]/20 hover:bg-[#15202B] hover:text-white transition-colors disabled:opacity-30 disabled:pointer-events-none";

  return (
    <div className="grid gap-3" data-testid="admin-artworks">
      <div className="flex flex-wrap items-center gap-4 mb-2">
        <button onClick={() => setEdit({})} className="btn-ink" data-testid="admin-add-artwork-button"><Plus className="w-4 h-4" />Ajouter une œuvre</button>
        <p className="text-sm text-[#55636F]">Les flèches changent l'ordre d'affichage dans la galerie.</p>
      </div>
      {items.map((a, idx) => (
        <article key={a.id} className="bg-white p-3 sm:p-4 shadow-sm grid grid-cols-[72px_1fr] sm:grid-cols-[88px_1fr_auto] gap-4 items-center" data-testid="admin-artwork-row">
          <img src={imgSrc(a.img)} alt="" className="w-[72px] h-[72px] sm:w-[88px] sm:h-[88px] object-cover bg-[#E9E2D6]" />
          <div className="min-w-0">
            <p className="font-medium truncate">{a.t}</p>
            <p className="text-sm text-[#55636F]">{idx + 1}. {CATS[a.cat] || ""} · <span className={a.vendu ? "text-[#A2372F]" : ""}>{priceLabel(a)}</span>{a.photos?.length ? ` · ${a.photos.length + 1} photos` : ""}{a.unique === false ? ` · stock : ${typeof a.stock === "number" ? a.stock : "illimité"}` : ""}</p>
            <div className="flex gap-1.5 mt-2">
              <button className={arrow} onClick={() => move(idx, 0)} disabled={idx === 0} aria-label="Mettre en premier" title="Mettre en premier" data-testid="admin-artwork-move-top"><ChevronsUp className="w-4 h-4" /></button>
              <button className={arrow} onClick={() => move(idx, idx - 1)} disabled={idx === 0} aria-label="Monter" data-testid="admin-artwork-move-up"><ArrowUp className="w-4 h-4" /></button>
              <button className={arrow} onClick={() => move(idx, idx + 1)} disabled={idx === items.length - 1} aria-label="Descendre" data-testid="admin-artwork-move-down"><ArrowDown className="w-4 h-4" /></button>
            </div>
          </div>
          <div className="col-span-2 sm:col-span-1 flex flex-wrap gap-2 text-sm">
            {confirm === a.id ? (
              <>
                <span className="self-center">Retirer cette œuvre ?</span>
                <button onClick={() => remove(a.id)} className="px-3 py-1.5 rounded-full bg-[#A2372F] text-white" data-testid="admin-artwork-delete-confirm">Retirer</button>
                <button onClick={() => setConfirm(null)} className="px-3 py-1.5 rounded-full border">Garder</button>
              </>
            ) : (
              <>
                <button onClick={() => setEdit(a)} className="px-3 py-1.5 rounded-full border border-[#15202B]/25 hover:bg-[#15202B] hover:text-white transition-colors" data-testid="admin-artwork-edit">Modifier</button>
                <button onClick={() => toggleSold(a)} className="px-3 py-1.5 rounded-full border border-[#15202B]/25 hover:bg-[#15202B] hover:text-white transition-colors" data-testid="admin-artwork-toggle-sold">{a.vendu ? "Remettre en vente" : "Marquer vendue"}</button>
                <button onClick={() => setConfirm(a.id)} className="px-3 py-1.5 rounded-full text-[#A2372F]" data-testid="admin-artwork-delete">Retirer</button>
              </>
            )}
          </div>
        </article>
      ))}
      {edit && <ArtworkEditor art={edit.id ? edit : null} onClose={() => setEdit(null)} onSaved={saved} />}
    </div>
  );
};
